import React from 'react'
import Accordion from '../component/Accordion'

function Service() {
    const services = [
        {
            title:"Recruitment Services",
            description:`<ul><li>Graduate Trainee Recruitment</li><li>Mid-Level & Executive Recruitment</li></ul>`
        },
        {
            title:"HR Outsourcing & Workforce Solutions",
            description:`<ul><li>HR Outsourcing Services</li><li>Payroll Management</li></ul>`
        },
        {
            title:"Assessment & Selection Services",
            description:`<ul><li>Psychometric Testing</li><li>Virtual Assessment Centre</li></ul>`
        }
    ]
  return (
            <span className="pt-120" id="services">
                <section className="faq__area pt-120">
                    <div className="container">
                        <div className="row mb-120 mt-none-30">
                            <div className="col-lg-10">
                                <div className="faq__wrapper faq__wrapper--2 mt-30">
                                    <h2 className="title">Services</h2>
                                    <ul className="accordion__box clearfix">
                                        {services.map((item, index) => (
                                            <Accordion key={index} title={item.title} content={item.description} />
                                        ))}
                                    </ul>
                            </div>
                            </div>
                        </div>     
                    </div>
                </section>
            </span>
  )
}

export default Service
